module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"other":"Your camera is unavailable. Please try another device."}}')
  delete Component.options._Ctor
}
